import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { pobDataModel } from '../../model'
import { Router } from '@angular/router'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-imeireset',
  template:  require('./imeireset.component.html'),
  styles: [],
})
export class IMEIResetComponent implements OnInit {
  private columnDefs;
  private rowHeight;

  api: any;
  busy: Subscription;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  stateList: any = [];
  IMEIData: any = [];
  headQuarterList: any = [];
  empName: any = [];
  token: any;
  IMEIDataModel: pobDataModel = new pobDataModel();

  IMEI_Form = new FormGroup({
    state: new FormControl('', [Validators.required]),
    hq: new FormControl('', [Validators.required]),
    employee: new FormControl('', [Validators.required]),
  });



  static parameters = [ApiService, Router, HttpClient, ToastrService]
  constructor(private apiService: ApiService, private router: Router, private http: HttpClient, private toastr: ToastrService) {
    this.apiService = apiService;
    let parent = this;
    this.columnDefs = [
      { headerName: 'Sr. No', valueGetter: "node.rowIndex + 1", width: 80 },
      { headerName: 'Employee Code', field: "Client_Code" },
      // { headerName: 'Employee Name', field: "Client_Name" },
      {
        headerName: 'Employee Name', field: "Client_Name", cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `
              <div class="grid_actions">
                  <span class="grid_actions_item viewBtn">`+ params.data.Client_Name + `</span>
              </div>
              `;
          var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
          viewButton.addEventListener('click', function () {
            var Confirm = confirm("Do You Want To Rest IMEI?");
            if (Confirm == true) {
              parent.resetIMEI(params.data);
            }
          });
          return eDiv;
        }
      },
      { headerName: 'Designation', field: "Designation" },
      { headerName: 'Head Qtr', field: "HQName" },
      { headerName: 'Division', field: "DivisionName" },
      { headerName: 'State', field: "StateName", suppressSizeToFit: true },
      { headerName: 'IMEI', field: "IMEI" },
    ];
    this.rowHeight = 50;
    this.defaultColDefine = { resizable: true };
  }



  ngOnInit() {
    $('#filter-option').trigger('click');
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.getState();
    this.getHeadQuarterList();
    this.getEmployee();
    this.IMEIDataModel.employeeCode = '0';
    this.IMEIDataModel.stateId = 0;
    this.IMEIDataModel.hq = 0;
  }


  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onBtnExport() {
    this.api.exportDataAsExcel({ fileName: 'IMEI_Report' });
  }

  onFilterTextBoxChanged() {
    this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api.refreshCells();
  }


  getState() {
    this.apiService.getState().subscribe((res: any) => {
      this.stateList = res.data;
    })
  }

  getHeadQuarterList() {
    this.apiService.getHeadQuarterList().subscribe((res: any) => {
      this.headQuarterList = res.data;
    })
  }


  getEmployee() {
    var data = {
      Id: this.token.id
    };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
      this.empName = res.data;
    })
  }

  getIMEIDetails() {
    this.IMEIDataModel.LoginId = this.token.id;
    this.busy = this.apiService.getIMEIDetails(this.IMEIDataModel).subscribe((res: any) => {
      this.IMEIData = res.data;

    })
  }

  resetIMEI(data) {
    // let data={userId:this.chemistmasterdataModel.Employee_ID}
    this.apiService.resetUserIMEI(data).subscribe((res: any) => {
      if (res.data.length > 0) {
        if (res.data[0].flag == 1) {
          this.toastr.success(res.data[0].msg);
          this.getIMEIDetails();
        }
        else {
          this.toastr.success(res.data[0].msg);
        }
      }

    })
  }
}
